//@flow
import * as React from 'react'
import cx from 'classnames'

import { useInfoBoxStyles } from './styles'

type InfoBoxProps = {
  ...React.ElementProps<'div'>,
  text: string
}

const InfoBox = ({ text, className, ...props }: InfoBoxProps) => {
  const classes = useInfoBoxStyles()
  return (
    <div className={cx(classes.infoBox, className)} {...props}>
      <i className="icon icon-m ">info</i>
      <p style={{ margin: 0 }}>{text}</p>
    </div>
  )
}

export { InfoBox }
